

<template>
    <div class="task-container">
        <a-table :data-source="tableSource" :rowKey="record => record.id" :pagination="false" bordered>
			<a-table-column key="title" title="任务名称" data-index="title" align="center"></a-table-column>
            <a-table-column key="action" title="操作" align="center">
                <template slot-scope="text, record">
                    <div class="task-table_btn">
                        <a class="task-table_btn" href="javascript:;" @click="viewKlassAssessment(record)">
                            <svg-icon iconClass="eye"></svg-icon>
                            <span class="task-table_btn_text">查看</span>
                        </a>
                        <a v-if="isManager" class="task-table_btn m-left-10" href="javascript:;" @click="updateTaskStatusHandle(record)">
                            <svg-icon iconClass="redo"></svg-icon>
                            <span class="task-table_btn_text">恢复</span>
                        </a>
                    </div>
                </template>
            </a-table-column>
        </a-table>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import AssessmentService from "@/api/assessmentService";
export default {
	name: "archivedTask",
	data() {
		return {
			tableSource: [],
		};
	},

	computed: {
		...mapGetters(["schoolInfo", "isManager"]),
	},

	created() {
		this.getTaskList();
	},

	methods: {
		getTaskList() {
			AssessmentService.getTaskListService({
				school_id: this.schoolInfo.id,
				status: "ARCHIVED"
			}).then((res = []) => {
				this.tableSource = res;
			});
		},


		updateTaskStatusHandle(record) {
			this.$confirm({
				title: "提示信息",
				content: `是否恢复评估任务 ${record.title}`,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						AssessmentService.updateTaskStatusService({
							taskId: record.id,
							isActive: false,
						})
							.then(() => {
								this.$message.success("操作成功");
								this.getTaskList();
								resolve();
							})
							.catch((err) => {
								this.$message.error("操作失败，请检查后重试");
								reject(err);
							});
					});
				},
			});
		},

        
		viewKlassAssessment(record) {
			this.$router.push({
				name: "archivedAssessmentList",
				query: { klass_id: record.klass_id, task_id: record.id, status: "ARCHIVED" },
			});
		},
	},
};
</script>

<style lang="less" scoped>
.task {
	&-container {
		background: #ffffff;
		min-height: calc(100% - 65px);
		margin-top: 15px;
		padding: 28px 28px 2px 30px;
	}

    &-table {
        &_btn {
            display: flex;
            flex-flow: nowrap row;
            align-items: center;
            justify-content: center;
            line-height: 1;

            &_text {
                margin-left: 5px;
                line-height: 1;
            }

            &_disabled {
                cursor: not-allowed;
                color: rgba(0, 0, 0, 0.25);
                border-color: #d9d9d9;
            }
        }
    }
}
</style>
